import { makeStyles, theme } from 'cdh-data-portal-theme'
import { USER_MENU_WIDTH } from './UserMenu.static'

export const useStyles = makeStyles()(() => ({
    root: {
        width: USER_MENU_WIDTH,
        padding: theme.globalPadding,
        backgroundColor: theme.colors.globalBackgroundLight,
        boxShadow: theme.shadows.strong,
        borderRadius: 8,
    },
    userInfo: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.globalPadding,
        borderBottom: `1px solid ${theme.colors.globalBackgroundDark}`,
        color: theme.textColors.primary,
    },
    displayName: {
        fontWeight: 600,
        color: theme.textColors.primary,
        paddingTop: theme.globalPadding,
        marginBottom: 4,
    },
    signOut: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 8,
        padding: '12px 16px',
        color: theme.textColors.primary,
        cursor: 'pointer',
        width: '100%',
        '&:hover': {
            color: theme.textColors.highlight,
        },
    },
}))
